function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.5; }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n  min-height: 40px;\n  \n  ",
        "\n  \n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  width: ",
        ";\n  height: ",
        ";\n  border: 3px solid transparent;\n  border-top: 3px solid ",
        ";\n  border-radius: 50%;\n  animation: ",
        " 1s linear infinite;\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.875rem;\n  color: var(--theme-text-secondary, #6b7280);\n  margin: 0;\n  \n  .dark & {\n    color: var(--theme-text-secondary-dark, #9ca3af);\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  animation: ",
        " 2s infinite;\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  height: 16px;\n  border-radius: 4px;\n  background-color: var(--theme-skeleton, #e5e7eb);\n  width: ",
        ";\n  margin-bottom: 12px;\n  \n  &:last-child {\n    margin-bottom: 0;\n  }\n  \n  .dark & {\n    background-color: var(--theme-skeleton-dark, #374151);\n  }\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
import React from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
var spin = keyframes(_templateObject());
var pulse = keyframes(_templateObject1());
var SpinnerContainer = styled.div(_templateObject2(), function(param) {
    var fullScreen = param.fullScreen;
    return fullScreen && "\n    position: fixed;\n    inset: 0;\n    background: var(--theme-background, #ffffff);\n    z-index: 9999;\n    \n    .dark & {\n      background: var(--theme-background-dark, #1f2937);\n    }\n  ";
}, function(param) {
    var overlay = param.overlay;
    return overlay && "\n    position: absolute;\n    inset: 0;\n    background: rgba(255, 255, 255, 0.8);\n    backdrop-filter: blur(4px);\n    z-index: 1000;\n    \n    .dark & {\n      background: rgba(31, 41, 55, 0.8);\n    }\n  ";
});
var Spinner = styled.div(_templateObject3(), function(param) {
    var size = param.size;
    switch(size){
        case 'sm':
            return '20px';
        case 'lg':
            return '40px';
        default:
            return '30px';
    }
}, function(param) {
    var size = param.size;
    switch(size){
        case 'sm':
            return '20px';
        case 'lg':
            return '40px';
        default:
            return '30px';
    }
}, function(param) {
    var color = param.color;
    switch(color){
        case 'primary':
            return 'var(--theme-primary, #3b82f6)';
        case 'secondary':
            return 'var(--theme-secondary, #6b7280)';
        case 'success':
            return 'var(--theme-success, #10b981)';
        case 'warning':
            return 'var(--theme-warning, #f59e0b)';
        case 'danger':
            return 'var(--theme-danger, #ef4444)';
        case 'default':
            return 'var(--theme-text, #374151)';
        default:
            return color;
    }
}, spin);
var Label = styled.p(_templateObject4());
var SkeletonContainer = styled.div(_templateObject5(), pulse, function(param) {
    var className = param.className;
    return className && "".concat(className);
});
var SkeletonLine = styled.div(_templateObject6(), function(param) {
    var width = param.width;
    return width || '100%';
});
/**
 * 로딩 스피너 컴포넌트
 * 다양한 크기와 스타일의 로딩 인디케이터 제공
 */ export function LoadingSpinner(param) {
    var _param_size = param.size, size = _param_size === void 0 ? 'md' : _param_size, _param_color = param.color, color = _param_color === void 0 ? 'primary' : _param_color, label = param.label, _param_className = param.className, className = _param_className === void 0 ? '' : _param_className, _param_fullScreen = param.fullScreen, fullScreen = _param_fullScreen === void 0 ? false : _param_fullScreen, _param_overlay = param.overlay, overlay = _param_overlay === void 0 ? false : _param_overlay;
    return /*#__PURE__*/ React.createElement(SpinnerContainer, {
        className: className,
        fullScreen: fullScreen,
        overlay: overlay
    }, /*#__PURE__*/ React.createElement(Spinner, {
        size: size,
        color: typeof color === 'string' ? color : color,
        "aria-label": "로딩 중",
        role: "status"
    }), label && /*#__PURE__*/ React.createElement(Label, null, label));
}
/**
 * 페이지 전체 로딩 컴포넌트
 */ export function PageLoading(param) {
    var _param_label = param.label, label = _param_label === void 0 ? '페이지를 불러오는 중...' : _param_label;
    return /*#__PURE__*/ React.createElement(LoadingSpinner, {
        fullScreen: true,
        label: label
    });
}
/**
 * 컨테이너 오버레이 로딩 컴포넌트
 */ export function OverlayLoading(param) {
    var _param_label = param.label, label = _param_label === void 0 ? '처리 중...' : _param_label;
    return /*#__PURE__*/ React.createElement(LoadingSpinner, {
        overlay: true,
        label: label
    });
}
/**
 * 인라인 로딩 컴포넌트 (작은 크기)
 */ export function InlineLoading(param) {
    var label = param.label;
    return /*#__PURE__*/ React.createElement(LoadingSpinner, {
        size: "sm",
        label: label
    });
}
/**
 * 버튼 로딩 컴포넌트 (버튼 내부용)
 */ export function ButtonLoading() {
    return /*#__PURE__*/ React.createElement(LoadingSpinner, {
        size: "sm",
        color: "current"
    });
}
/**
 * 스켈레톤 로딩 컴포넌트
 */ export function SkeletonLoading(param) {
    var _param_lines = param.lines, lines = _param_lines === void 0 ? 3 : _param_lines, _param_className = param.className, className = _param_className === void 0 ? '' : _param_className;
    return /*#__PURE__*/ React.createElement(SkeletonContainer, {
        className: className
    }, Array.from({
        length: lines
    }).map(function(_, index) {
        return /*#__PURE__*/ React.createElement(SkeletonLine, {
            key: index,
            width: index === lines - 1 ? '75%' : '100%'
        });
    }));
}
/**
 * 채팅 메시지 스켈레톤 로딩
 */ export function ChatMessageSkeleton() {
    return /*#__PURE__*/ React.createElement(SkeletonContainer, {
        style: {
            padding: '16px'
        }
    }, /*#__PURE__*/ React.createElement("div", {
        style: {
            display: 'flex',
            gap: '12px'
        }
    }, /*#__PURE__*/ React.createElement("div", {
        style: {
            width: '32px',
            height: '32px',
            borderRadius: '50%',
            backgroundColor: 'var(--theme-skeleton, #e5e7eb)'
        }
    }), /*#__PURE__*/ React.createElement("div", {
        style: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: '8px'
        }
    }, /*#__PURE__*/ React.createElement("div", {
        style: {
            height: '16px',
            width: '80px',
            borderRadius: '4px',
            backgroundColor: 'var(--theme-skeleton, #e5e7eb)'
        }
    }), /*#__PURE__*/ React.createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '4px'
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLine, {
        width: "100%"
    }), /*#__PURE__*/ React.createElement(SkeletonLine, {
        width: "80%"
    }), /*#__PURE__*/ React.createElement(SkeletonLine, {
        width: "60%"
    })))));
}
/**
 * 카드 스켈레톤 로딩
 */ export function CardSkeleton(param) {
    var _param_showAvatar = param.showAvatar, showAvatar = _param_showAvatar === void 0 ? true : _param_showAvatar, _param_showActions = param.showActions, showActions = _param_showActions === void 0 ? true : _param_showActions;
    return /*#__PURE__*/ React.createElement(SkeletonContainer, {
        style: {
            borderRadius: '8px',
            border: '1px solid var(--theme-border, #e5e7eb)',
            padding: '16px'
        }
    }, /*#__PURE__*/ React.createElement("div", {
        style: {
            display: 'flex',
            gap: '12px',
            alignItems: 'flex-start'
        }
    }, showAvatar && /*#__PURE__*/ React.createElement("div", {
        style: {
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            backgroundColor: 'var(--theme-skeleton, #e5e7eb)'
        }
    }), /*#__PURE__*/ React.createElement("div", {
        style: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: '12px'
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLine, {
        width: "33%"
    }), /*#__PURE__*/ React.createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '8px'
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLine, {
        width: "100%"
    }), /*#__PURE__*/ React.createElement(SkeletonLine, {
        width: "80%"
    })), showActions && /*#__PURE__*/ React.createElement("div", {
        style: {
            display: 'flex',
            gap: '8px'
        }
    }, /*#__PURE__*/ React.createElement("div", {
        style: {
            height: '32px',
            width: '64px',
            borderRadius: '4px',
            backgroundColor: 'var(--theme-skeleton, #e5e7eb)'
        }
    }), /*#__PURE__*/ React.createElement("div", {
        style: {
            height: '32px',
            width: '64px',
            borderRadius: '4px',
            backgroundColor: 'var(--theme-skeleton, #e5e7eb)'
        }
    })))));
}
var LoadingSpinnerComponent = function(props) {
    return /*#__PURE__*/ React.createElement(LoadingSpinner, props);
};
export default LoadingSpinnerComponent;
